<template>
    <v-container fluid grid-list-md class="bot-add-user">
        <div class="headline ma-3 text-color-vip bold">
            Bot Tương Tác
        </div>
        <div class="container-tabs" v-if="maintain">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>
        <v-layout row wrap v-else>
            <v-flex md12>
                <div class="card card-default">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="mdi mdi-heart-outline"></i>
                            Tạo mới bot tương tác
                        </h3>
                    </div>
                    <div class="card-body">
                        <v-form ref="form_bot_order_process" v-model="valid" lazy-validation>
                            <input type="hidden" name="token_proxy" v-model="tokenProxy" id="token_proxy">
                            <input type="hidden" name="cookie_hide" id="cookie-hide">
                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Chọn Proxy Riêng</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-row no-gutters>
                                        <v-col cols="9">
                                            <v-select
                                                    solo
                                                    :items="proxies"
                                                    v-model="proxy"
                                                    item-text="text"
                                                    item-value="value"
                                                    required
                                                    :rules="proxyRule"
                                                    hide-details="auto"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="2" class="ml-2 pt-2 extension-cookie">
                                            <v-btn class="deep-purple lighten-4" id="get-cookie-extension">
                                                Lấy cookie
                                            </v-btn>

                                            <v-btn href="/extensions/get-cookie-and-access-token" class="deep-purple lighten-4" id="update-cookie-extension">
                                                Update extension
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <small class="content-note">
                                        Lưu ý: <br>
                                        1. Không chọn Proxy riêng thì sẽ chạy trên 1 proxy chung với nhiều nick khác,
                                        khả năng checkpoint sẽ cao hơn. <br>
                                        2. Để có proxy riêng xin vui lòng chọn mục “Mua Proxy riêng” ở menu để mua.<br>
                                        <span style="color: #ca4646">3. Nên thao tác trên trình duyệt chorme. Tải tiện ích chrome để lấy cookie và hướng dẫn lấy cookie qua proxy tại <a
                                                target='__blank'
                                                href="/extensions/get-cookie-and-access-token">tại đây</a> .</span><br>
                                        <span style="color: #ca4646">4. Sau khi cài đặt extension, nhấn f5 để kích hoạt extension.</span>
                                    </small>
                                </v-flex>
                            </v-layout>

                            <!--videoRef-->
                            <v-layout align-center row v-if="videoId">
                                <v-flex md2>
                                </v-flex>
                                <v-flex md10>
                                    <div class="v-sheet theme--light explain">
                                        <a href="#videoRef">
                                            <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                        </a>
                                    </div>
                                </v-flex>
                            </v-layout>
                            
                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Cookie</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="tokenCookie"
                                            placeholder="Nhập cookie tài khoản Facebook cần cài Bot"
                                            required
                                            :rules="tokenCookieRule"
                                            hide-details="auto"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!----note---->
                            <v-layout align-center row>
                                <v-flex md2>
                                </v-flex>
                                <v-flex md10>
                                    <div class="v-sheet theme--light explain">
                                        <span class="red_text">
                                            Lưu ý:<br>
                                            Với các tài khoản mới bắt đầu chạy BOT sẽ bị hiện tượng xác minh hoặc khóa tài khoản vì thay đổi địa chỉ ip.<br>
                                            Các bạn vui lòng xác minh hoặc mở khóa tài khoản rồi lấy lại cookie, cập nhật lại cookie trong phần DANH SÁCH NGƯỜI DÙNG.
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Name</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="customerName"
                                            placeholder="Tên khách hàng"
                                            disabled
                                            required
                                            :rules="customerNameRule"
                                            hide-details="auto"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Tương tác với</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-select
                                            solo
                                            :items="interactWiths"
                                            v-model="interactWith"
                                            item-text="text"
                                            item-value="value"
                                            required
                                            :rules="interactWithRule"
                                            hide-details="auto"
                                    ></v-select>
                                </v-flex>
                            </v-layout>


                            <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                <v-flex>
                                    <label class="text-color">Lọc List UID User Facebook</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-checkbox
                                            class="mt-0"
                                            v-model="listIdUser"
                                            label="Nhập list UID chủ bài viết để bot tương tác lọc trên newfeed"
                                    ></v-checkbox>
                                    <v-textarea
                                            v-if="listIdUser"
                                            solo
                                            v-model="userIds"
                                            placeholder="Nhập list UID chủ bài viết để bot tương tác lọc trên newfeed, mỗi UID là một dòng"
                                            required
                                            hide-details="auto"
                                    ></v-textarea>
                                    <small>
                                        Lấy UID user, UID page, UID group trên trang
                                        <a href="https://uid.bufflike.net" target="_blank">https://uid.bufflike.net</a>.
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                <v-flex>
                                    <label class="text-color">Lọc List UID Page</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-checkbox
                                            class="mt-0"
                                            v-model="listIdPage"
                                            label="Nhập list UID page để bot tương tác lọc trên newfeed"
                                    ></v-checkbox>
                                    <v-textarea
                                            v-if="listIdPage"
                                            solo
                                            v-model="pageIds"
                                            placeholder="Nhập list UID page để bot tương tác lọc trên newfeed, mỗi UID là một dòng"
                                            required
                                            hide-details="auto"
                                    ></v-textarea>
                                    <small>
                                        Lấy UID user, UID page, UID group trên trang
                                        <a href="https://uid.bufflike.net" target="_blank">https://uid.bufflike.net</a>.
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4" v-show="interactWith === 3">
                                <v-flex md2>
                                    <label class="text-color">Lọc List UID Group</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-checkbox
                                            class="mt-0"
                                            v-model="listIdGroup"
                                            label="Nhập list UID group để bot tương tác lọc trên newfeed"
                                    ></v-checkbox>
                                    <v-textarea
                                            v-if="listIdGroup"
                                            solo
                                            v-model="groupIds"
                                            placeholder="Nhập list UID group để bot tương tác lọc trên newfeed, mỗi UID là một dòng"
                                            required
                                            hide-details="auto"
                                    ></v-textarea>
                                    <small>
                                        Lấy UID user, UID page, UID group trên trang
                                        <a href="https://uid.bufflike.net" target="_blank">https://uid.bufflike.net</a>.
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex>
                                    <label class="text-color">Cảm xúc</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-select
                                            solo
                                            :items="reactions"
                                            v-model="reaction"
                                            item-text="text"
                                            item-value="value"
                                            required
                                            hide-details="auto"
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Bot comment</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-radio-group v-model="offComment" class="mt-0" row hide-details="auto">
                                        <v-radio
                                                label="Tắt"
                                                :value="false"
                                        ></v-radio>
                                        <v-radio
                                                label="Bật"
                                                :value="true"
                                        ></v-radio>
                                    </v-radio-group>
                                    <small class="content-note">
                                        Tỉ lệ giữa comment và reaction là {{ this.commentPercent }}:{{ 100 -
                                        this.commentPercent }}
                                    </small>
                                </v-flex>

                            </v-layout>


                            <v-layout row class="pa-0 mb-4" v-show="offComment">
                                <v-flex md2>
                                    <label class="text-color">Nội dung</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-textarea
                                            name="input-7-4"
                                            solo
                                            v-model="commentList"
                                            placeholder="Lưu ý: Nếu bạn muốn chạy nhiều nội dung khác nhau thì nhập mỗi nội dung 1 dòng."
                                            required
                                            hide-details="auto"
                                    ></v-textarea>
                                    <small class="content-note">
                                        Lệnh:<br>
                                        {icon} = random emoji<br>
                                        {time} = thêm thời gian hiện tại vào comment<br>
                                        {tag:100009139678233} = tag page hoặc user vào comment, có thể tag nhiều đối
                                        tượng trong 1 comment<br>
                                        {owner}: tag tên chủ post<br>
                                        {break}: xuống dòng mới trong comment<br>
                                        {A|B|C}: spin ngãu nhiên lựa chọn nhãn <br>
                                        Ví dụ: tôi {yêu|ghét|giận} {tag:100009139678233} từ thời điểm {time} {icon}.{break}Em biết không?<br>
                                        Lưu ý: Nếu bạn muốn chạy nhiều nội dung khác nhau thì nhập mỗi nội dung 1 dòng.
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4" v-show="offComment">
                                <v-flex md2>
                                    <label class="text-color">Comment ảnh</label>
                                </v-flex>
                                <v-card width="20%" height="300px">
                                    <v-card-text>
                                        <v-radio-group v-model="mediaComment" row>
                                            <v-radio
                                                    class="mb-3"
                                                    label="Upload ảnh"
                                                    value="image_upload"
                                            ></v-radio>
                                            <v-radio
                                                    class="mb-3"
                                                    label="Chọn ảnh từ hệ thống"
                                                    value="image_system"
                                            ></v-radio>
                                            <v-radio
                                                    label="Bình luận sticker"
                                                    value="sticker"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-card-text>
                                </v-card>
                                <v-card class="ml-5" width="60%" min-height="300px">
                                    <v-card-text v-if="mediaComment === 'image_upload'">
                                        <v-file-input
                                                class="col-5 float-right"
                                                counter
                                                small-chips
                                                multiple
                                                show-size
                                                truncate-length="10"
                                                v-model="imageUploadComment"
                                        ></v-file-input>
                                        <v-text-field
                                                class="col-3 float-right"
                                                solo
                                                v-model="imageText"
                                                type="text"
                                                placeholder="Chữ in trên ảnh"
                                        ></v-text-field>
                                        <small class="content-note">
                                            Lệnh:<br>
                                            {owner} = Thêm tên chủ post vào ảnh <br>
                                            Lưu ý: Lệnh {owner} khi được thêm thì các ký tự khác sẽ bị xóa
                                        </small>
                                    </v-card-text>

                                    <v-card-text v-if="mediaComment === 'sticker'">
                                        <v-select
                                                solo
                                                :items="stickers"
                                                v-model="sticker"
                                                item-text="text"
                                                item-value="value"
                                        ></v-select>
                                        <v-card max-height="300" class="overflow-y-auto">
                                            <v-row>
                                                <v-col cols="6"
                                                       sm="2"
                                                       v-for="img in stickerImage"
                                                       :key="img">
                                                    <v-img :height="130"
                                                           :src="img"
                                                    ></v-img>
                                                </v-col>
                                            </v-row>
                                        </v-card>

                                        <small class="content-note">
                                            Sticker sẽ được comment ngẫu nhiên trong gói được chọn
                                        </small>
                                    </v-card-text>

                                    <v-card-text v-if="mediaComment === 'image_system'">
                                        <v-select
                                                solo
                                                :items="imageSystemList"
                                                v-model="imageSystemComment"
                                                item-text="text"
                                                item-value="value"
                                        ></v-select>
                                        <v-card max-height="300" class="overflow-y-auto">
                                            <v-row>
                                                <v-col cols="6"
                                                       sm="2"
                                                       v-for="img in imageTheme"
                                                       :key="img">
                                                    <v-img :height="130"
                                                           :src="img"
                                                    ></v-img>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                        <v-text-field
                                                class="col-3 float-right"
                                                solo
                                                v-model="imageText"
                                                type="text"
                                                placeholder="Chữ in trên ảnh"
                                        ></v-text-field>
                                        <small class="content-note">
                                            Lệnh:<br>
                                            {owner} = Thêm tên chủ post vào ảnh <br>
                                            Lưu ý: Lệnh {owner} khi được thêm thì các ký tự khác sẽ bị xóa,
                                            ảnh comment sẽ được random trong chủ đề được chọn
                                        </small>
                                    </v-card-text>

                                </v-card>
                            </v-layout>

                            <!--<v-layout  row class="pa-0 mb-4" v-show="offComment">-->
                            <!--                                <v-flex md2>-->
                            <!--                                    <label class="text-color">Tăng like/reaction cho comment</label>-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex md10>-->
                            <!--                                    <v-checkbox-->
                            <!--                                            v-model="topComment"-->
                            <!--                                    ></v-checkbox>-->
                            <!--                                        <small class="content-note">-->
                            <!--                                            Lưu ý: Bạn nên chọn tính năng này khi comment vào group và page. Khi tăng like cho comment của bạn thì comment đó sẽ được lên top, được nhiều người nhìn thấy hơn.-->
                            <!--                                        </small>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->


                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Bài viết/phút</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-select
                                            solo
                                            :items="frequencies"
                                            v-model="frequency"
                                            item-text="text"
                                            item-value="value"
                                            :rules="frequencyRule"
                                            hide-details="auto"
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Blacklist (không bot)</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-textarea
                                            solo
                                            v-model="blackList"
                                            placeholder="Nhập list UID Facebook mà bạn muốn Bot không chạy, mỗi UID là một dòng"
                                            required
                                            hide-details="auto"
                                    ></v-textarea>
                                    <small>
                                        Lấy UID user, UID page, UID group trên trang
                                        <a href="https://uid.bufflike.net" target="_blank">https://uid.bufflike.net</a>.
                                    </small>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Thời gian hoạt động</label>
                                </v-flex>
                                <v-flex md4>
                                    <v-select
                                            solo
                                            :items="timeStarts"
                                            v-model="timeStart"
                                            item-text="text"
                                            item-value="value"
                                            hide-details="auto"
                                    ></v-select>
                                </v-flex>

                                <v-flex md2 style="text-align: center;">
                                    <label class="text-color">đến</label>
                                </v-flex>
                                <v-flex md4>
                                    <v-select
                                            solo
                                            :items="timeEnds"
                                            v-model="timeEnd"
                                            item-text="text"
                                            item-value="value"
                                            hide-details="auto"
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Số ngày thuê</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="noDay"
                                            type="number"
                                            required
                                            :rules="noDayRule"
                                            hide-details="auto"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                    <label class="text-color">Ghi chú</label>
                                </v-flex>
                                <v-flex md10>
                                    <v-text-field
                                            solo
                                            v-model="note"
                                            placeholder="Thêm ghi chú người dùng (có thể để trống)"
                                            required
                                            hide-details="auto"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row class="pa-0 mb-4">
                                <v-flex md2>
                                </v-flex>
                                <v-flex md10>
                                    <ul>
                                        <li>Nick phải bật Bảo Mật 2 Lớp trước khi cài đặt BOT.</li>
                                        <li>Thời gian thuê cho phép từ 1 ngày đến 150 ngày.</li>
                                        <li>Đổi Pass hoặc Đăng Xuất FB = DIE Token or Cookie.</li>
                                    </ul>
                                </v-flex>
                            </v-layout>
                        </v-form>

                        <v-layout row class="pa-0 mb-4">
                            <v-flex md12>
                                <v-card style="background-color: #fff">
                                    <v-card-title>
                                        <div class="div-total">
                                            <h5>Tổng : <span class="font-weight-bold">
                                            <span class="text-primary">{{ totalCoin  }}</span></span>
                                                <small>coin</small>
                                            </h5>
                                            <h6 class="mb-0">Giá Bot Reaction của bạn là <span class="text-primary">{{ price  }}</span>
                                                <small>coin</small>/ngày</h6>
                                        </div>
                                    </v-card-title>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout row class="pa-0 mb-4">
                            <v-flex md12>
                                <v-btn width="100%" height="50px" style="background-color: #007bff"
                                       class="white--text payment"
                                       @click="saveProcess">
                                    <i class="mdi mdi-cart"></i>
                                    THANH TOÁN
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <!--video youtube-->
        <v-layout align-center row v-if="videoId" id="videoRef">
            <v-flex md12>
                <div class="col-sm-12 mb-n3">
                    <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                </div>
                <div class="col-sm-12 mb-n3">
                    <youtube :video-id="videoId" ref="youtube"
                             @buffering="playing"
                             @paused="paused"
                             @ended="paused"
                             @playing="playing"
                             width="100%" height="650px">
                    </youtube>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import Swal from 'sweetalert2'
  import {
    BOT_INTERACTION_GET_USER_FORM,
    BOT_INTERACTION_SAVE_ORDER,
    BOT_INTERACTION_GET_USER_COOKIE,
    BOT_INTERACTION_GET_IMAGE_THEME,
    SEEDING_TYPE_MAINTAIN,
    BOT_INTERACTION_GET_STICKER_IMAGE,
    FB_POST_GET_LIST_SEEDING
  } from '../../store/actions.type'
  import { COMMON_SET_LOADING } from '../../store/mutations.type'
  import { SEEDING_TYPE } from '~/config/constant'

  import Vue from 'vue'
  import VueLodash from 'vue-lodash'
  import lodash from 'lodash'
  import { COMMON_SET_SNACK } from '~/store/mutations.type'
  import VueMobileDetection from 'vue-mobile-detection'
  import browserDetect from "vue-browser-detect-plugin";

  Vue.use(browserDetect);
  Vue.use(VueMobileDetection)
  Vue.use(VueLodash, { lodash: lodash })

  export default {
    data () {
      return {
        maintain: false,

        tokenCookie: '',
        customerName: '',
        tokenProxy: '',

        // proxies
        proxies: [],
        proxy: 0,

        // interactWiths
        interactWiths: [
          { value: 1, text: 'Chỉ bài viết của bạn bè' },
          { value: 2, text: 'Tất cả bài viết trên newfeed' },
          { value: 3, text: 'Tương tác theo list UID (Chạy bằng Cookie)' },
        ],
        interactWith: 1,

        // userIds
        userIds: '',
        userIdsArray: [],
        listIdUser: false,

        // pageIds
        pageIds: '',
        pageIdsArray: [],
        listIdPage: false,

        // groupIds
        groupIds: '',
        groupIdsArray: [],
        listIdGroup: false,

        // reactions
        reactions: [],
        reaction: 0,

        // offComment
        offComment: false,

        // frequencies
        frequencies: [],

        frequency: 1,

        // blackList
        blackList: '',
        blackListArray: [],

        // timeStarts
        timeStarts: [
          { value: 0, text: '0 giờ' },
          { value: 1, text: '1 giờ' },
          { value: 2, text: '2 giờ' },
          { value: 3, text: '3 giờ' },
          { value: 4, text: '4 giờ' },
          { value: 5, text: '5 giờ' },
          { value: 6, text: '6 giờ' },
          { value: 7, text: '7 giờ' },
          { value: 8, text: '8 giờ' },
          { value: 9, text: '9 giờ' },
          { value: 10, text: '10 giờ' },
          { value: 11, text: '11 giờ' },
          { value: 12, text: '12 giờ' },
          { value: 13, text: '13 giờ' },
          { value: 14, text: '14 giờ' },
          { value: 15, text: '15 giờ' },
          { value: 16, text: '16 giờ' },
          { value: 17, text: '17 giờ' },
          { value: 18, text: '18 giờ' },
          { value: 19, text: '19 giờ' },
          { value: 20, text: '20 giờ' },
          { value: 21, text: '21 giờ' },
          { value: 22, text: '22 giờ' },
          { value: 23, text: '23 giờ' },
        ],
        timeStart: 6,

        // timeEnds
        timeEnds: [
          { value: 0, text: '0 giờ' },
          { value: 1, text: '1 giờ' },
          { value: 2, text: '2 giờ' },
          { value: 3, text: '3 giờ' },
          { value: 4, text: '4 giờ' },
          { value: 5, text: '5 giờ' },
          { value: 6, text: '6 giờ' },
          { value: 7, text: '7 giờ' },
          { value: 8, text: '8 giờ' },
          { value: 9, text: '9 giờ' },
          { value: 10, text: '10 giờ' },
          { value: 11, text: '11 giờ' },
          { value: 12, text: '12 giờ' },
          { value: 13, text: '13 giờ' },
          { value: 14, text: '14 giờ' },
          { value: 15, text: '15 giờ' },
          { value: 16, text: '16 giờ' },
          { value: 17, text: '17 giờ' },
          { value: 18, text: '18 giờ' },
          { value: 19, text: '19 giờ' },
          { value: 20, text: '20 giờ' },
          { value: 21, text: '21 giờ' },
          { value: 22, text: '22 giờ' },
          { value: 23, text: '23 giờ' },
        ],

        // comment
        mediaComment: 'image_upload',
        commentList: '',
        commentListArray: [],
        topComment: false,

        // sticker
        stickers: [],
        sticker: '',
        stickerImage: [],

        imageUploadComment: [],
        imageSystemList: [{ value: 0, text: 'Chọn tất cả các chủ đề' }],
        imageSystemComment: 0,

        imageTheme: [],

        timeEnd: 22,

        // noDay
        noDay: 10,

        // note
        note: '',

        // image text
        imageText: '',

        price: 0,

        totalCoin: 0,

        // comment percent
        commentPercent: 50,

        // rules
        valid: true,

        tokenCookieRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        customerNameRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        proxyRule: [
          // v => !!v || 'Trường này là bắt buộc',
        ],
        interactWithRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        imageCommentRule: [
          // value => !value || value.size < 2000000 || 'Ảnh upload không quá 2MB',
        ],
        frequencyRule: [
          v => !!v || 'Trường này là bắt buộc',
        ],
        noDayRule: [
          v => !!v || 'Trường này là bắt buộc',
          v => v >= 1 || 'Ngày thuê ít nhât 1 ngày',
        ],
        videoId: '', 
        videoStatus: true,
      }
    },

    created () {
      this.checkMaintain()
      this.customDataFromApi()
      this.getImageTheme()
      this.getImageSticker()
      this.getCookieUserDebounce = Vue.lodash.debounce(this.getCookieUser, 300)
    },

    watch: {
      noDay () {
        this.calculate()
      },

      tokenCookie () {
        this.getCookieUserDebounce()
      },

      userIds () {
        this.userIdsArray = this.userIds.match(/[^\r\n]+/g)
      },

      groupIds () {
        this.groupIdsArray = this.groupIds.match(/[^\r\n]+/g)
      },

      pageIds () {
        this.pageIdsArray = this.pageIds.match(/[^\r\n]+/g)
      },

      blackList () {
        this.blackListArray = this.blackList.match(/[^\r\n]+/g)
      },

      commentList () {
        if (this.commentList.trim() !== '') {
          this.commentListArray = this.commentList.match(/[^\r\n]+/g).map(function (comment) {
            let text = this.imageText.trim().search('{owner}') > -1 ? '{owner}' : this.imageText.trim()
            return {
              'content': comment,
              'image_text': text,
              'has_image_text': text !== ''
            }
          }.bind(this))
        } else {
          this.commentListArray = []
        }
      },

      imageSystemComment () {
        this.getImageTheme()
      },

      sticker () {
        this.getImageSticker()
      },

      proxy () {
        if (this.customerName !== '') {
          this.$store.commit(COMMON_SET_SNACK, {
            message: 'Vui lòng lấy lại cookie theo proxy',
            type: 'error'
          })
        }
        this.tokenCookie = ''
        this.customerName = ''
        this.tokenProxy = this.proxies.filter(proxy => proxy.value === this.proxy)[0].token
      }
    },

    methods: {
      copyTokenClipboard () {
        let textArea = document.createElement('textarea')
        textArea.value = this.proxies.filter(proxy => proxy.value === this.proxy)[0].token
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('Copy')
        textArea.remove()
        this.$store.commit(COMMON_SET_SNACK, {
          message: 'Copied proxy code',
          type: 'success'
        })
      },

      async checkMaintain () {
        let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN)
        if (dataInfo.includes(SEEDING_TYPE.ID_BOT_INTERACTION)) {
          this.maintain = true
        }
      },

      async customDataFromApi () {
        this.$store.commit(COMMON_SET_LOADING, true)
        let data = await this.$store.dispatch(BOT_INTERACTION_GET_USER_FORM)
        this.price = data.price

        this.reactions = data.reactions
        this.reaction = data['reactions'][0].value

        this.interactWiths = data['interaction_withs']
        this.interactWith = data['interaction_withs'][0].value

        this.proxies = data.proxies

        this.stickers = data['sticker_pack']
        this.sticker = this.stickers[0].value

        this.imageSystemList = data['image_pack']
        this.imageSystemList[0].text = 'Chọn tất cả các chủ đề'
        this.imageSystemComment = this.imageSystemList[0].value

        this.frequencies = data.frequencies
        this.frequency = this.frequencies[0].value

        this.commentPercent = data['comment_percent']

        this.initDefault()
        this.$store.commit(COMMON_SET_LOADING, false)

          this.listSeedingApi = await this.$store.dispatch(FB_POST_GET_LIST_SEEDING)
          for (let i = 0; i < this.listSeedingApi.length; i++) {
              if (this.listSeedingApi[i].type === 'bot-interaction') {
                  if (this.listSeedingApi[i].video) {
                      let videoId = this.youtube_parser(this.listSeedingApi[i].video)
                      if (videoId) {
                          this.videoId = videoId
                      }
                  }
              }
          }
      },

      async getCookieUser () {
        if (this.tokenCookie !== '') {
          this.$store.commit(COMMON_SET_LOADING, true)
          let data = null;
          let i = 0;
          const check = true;
          let proxyError = false;
          while (check) {
            if (i > 11 || data !== null) {
              break
            }
            if (i === 0) {
              this.$store.dispatch(BOT_INTERACTION_GET_USER_COOKIE, {
                cookie: this.tokenCookie,
                proxy: this.proxy
              }).then(rp => {
                data = rp
              }).catch(er => {
                data = er
              })
            }

            if (i > 10) {
              proxyError = true
              this.$store.commit(COMMON_SET_LOADING, false)
            }
            await new Promise(r => setTimeout(r, 1000));
            i++
          }

          if (proxyError) {
            Swal.fire({
              title: 'Xin lỗi bất tiện này',
              text: 'Proxy bạn mua hiện bị lỗi, vui lòng liên hệ bộ phận hỗ trợ để hỗ trợ.',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }

          this.customerName = data.name
          this.$store.commit(COMMON_SET_LOADING, false)
        }
      },

      initDefault () {
        this.calculate()
      },

      async calculate () {
        this.totalCoin = this.price * this.noDay
      },

      validateForm () {
        let check = this.$refs.form_bot_order_process.validate()
        let message = 'Thông tin điền đang chưa chính xác'
        if (this.offComment && !this.commentListArray.length) {
          check = false
          message += '<br> Nội dung bình luận không được để trống '
        }

        if (this.interactWith === 3) {
          if (this.listIdUser && !this.userIdsArray.length) {
            check = false
            message += '<br> List id user không được để trống'
          }

          if (this.listIdGroup && !this.groupIdsArray.length) {
            check = false
            message += '<br> List id group không được để trống'
          }

          if (this.listIdPage && !this.pageIdsArray.length) {
            check = false
            message += '<br> List id page không được để trống'
          }
        }

        if (this.timeStart > this.timeEnd) {
          check = false
          message += '<br> Thời gian hoạt động sau phải lớn hơn trước'
        }

        let proxy = this.proxies.filter(item => item.value === this.proxy)[0]
        if (typeof proxy !== 'undefined' && proxy['date_expire'] < this.noDay) {
          check = false
          message += `<br> Hạn sử dụng ip của bạn là ${proxy['date_expire']} ngày, không đủ để thuê bot ${this.noDay} ngày`
        }

        if (this.timeStart > this.timeEnd) {
          check = false
          message += '<br> Thời gian hoạt động sau phải lớn hơn trước'
        }

        return { check: check, message: message }
      },

      async saveProcess () {
        this.calculate()
        let validateForm = this.validateForm()
        if (validateForm.check) {
          try {
            Swal.fire({
              title: 'Xác nhận',
              text: 'Bạn có chắc chắn muốn tạo tiến trình ',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Đồng ý!',
              cancelButtonText: 'Không'
            }).then((result) => {
              if (result.value) {
                this.overlay = true
                this.saveProcessApi()
              }
            })
          } catch (error) {
            console.log(error)
          }
        } else {
          Swal.fire(
            validateForm.message,
            '...',
            'error'
          )
        }
      },

      getParams () {
        let formData = new FormData()

        if (!this.offComment) {
          this.commentListArray = []
          this.sticker = ''
          this.topComment = false
          this.imageUploadComment = []
        }

        if (this.interactWith !== 3) {
          this.userIdsArray = []
          this.pageIdsArray = []
          this.groupIdsArray = []
        }

        if (this.mediaComment !== 'sticker') {
          this.sticker = ''
        }

        if (this.mediaComment === 'sticker') {
          this.imageUploadComment = []
        }

        formData.append('cookie', this.tokenCookie)
        formData.append('customer_ip_id', this.proxy)
        formData.append('interaction_id', this.interactWith)
        formData.append('user_ids', JSON.stringify(this.userIdsArray))
        formData.append('page_ids', JSON.stringify(this.pageIdsArray))
        formData.append('group_ids', JSON.stringify(this.groupIdsArray))
        formData.append('reaction_id', this.reaction)
        formData.append('comment', JSON.stringify(this.commentListArray))
        formData.append('post_per_minute', this.frequency)
        formData.append('black_ids', JSON.stringify(this.blackListArray))
        formData.append('time_range', `${this.timeStart}-${this.timeEnd}`)
        formData.append('date_hire', this.noDay)
        formData.append('note', this.note)
        formData.append('top_comment', this.topComment)
        formData.append('sticker', this.sticker)
        formData.append('has_image_text', this.imageText.trim() !== '')

        let text = this.imageText.trim().search('{owner}') > -1 ? '{owner}' : this.imageText.trim()
        formData.append('image_text', text)

        formData.append('comment_image_type', this.mediaComment)
        formData.append('image_pack', this.imageSystemComment)
        if (this.imageUploadComment.length) {
          for (let file of this.imageUploadComment) {
            formData.append('image_comment[]', file)
          }
        }
        return formData
      },

      async saveProcessApi () {
        this.$store.commit(COMMON_SET_LOADING, true)
        await this.$store.dispatch(BOT_INTERACTION_SAVE_ORDER, this.getParams())
        this.$store.commit(COMMON_SET_LOADING, false)

      },

      async getImageTheme () {
        this.$store.commit(COMMON_SET_LOADING, true)
        this.imageTheme = await this.$store.dispatch(BOT_INTERACTION_GET_IMAGE_THEME, { id: this.imageSystemComment })
        this.$store.commit(COMMON_SET_LOADING, false)
      },

      async getImageSticker () {
        if (this.sticker !== '') {
          this.$store.commit(COMMON_SET_LOADING, true)
          this.stickerImage = await this.$store.dispatch(BOT_INTERACTION_GET_STICKER_IMAGE, { id: this.sticker })
          this.$store.commit(COMMON_SET_LOADING, false)
        }
      },
        playing() {
            this.videoStatus = false;
        },
        paused() {
            this.videoStatus = true;
        },
        youtube_parser(url) {
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }
    },

    mounted () {
      setInterval(() => {
        let cookie = window.$('#cookie-hide').val()
        if (cookie !== '' && this.tokenCookie !== cookie) {
          this.tokenCookie = cookie
          window.$('#cookie-hide').val('')
        }
      }, 500)

      if (this.$isMobile() || !this.$browserDetect.isChrome) {
        window.$('.extension-cookie').css('display', 'none')
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "../../scss/main";

    .v-content .v-content__wrap {
        background-color: #f4f6f9;
    }

    .flex {
        padding-right: 7.5px !important;
        padding-left: 7.5px !important;
    }

    .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .card {
        box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
        margin-bottom: 1rem;
        min-width: 0;
        background-color: #fff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, .125);
        border-radius: .25rem;
    }

    .card-title i.mdi {
        font-size: 20px;
    }

    .card-title {
        float: left;
        font-size: 1.1rem;
        font-weight: 400;
        margin: 0;
    }

    .card-body {
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    .text-color {
        color: #000;
    }

    .v-text-field__details {
        display: flex !important;
    }

    form.v-form {
        margin-bottom: 2rem;
    }

    .bot-add-user {
        .div-total {
            width: 100%;
            color: #000;
            text-align: center;

            h5 {
                font-size: 1.2rem;
                margin-bottom: 0.5rem;
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
            }

            h6 {
                font-family: inherit;
                font-weight: 400;
                line-height: 1.2;
                color: inherit;
                font-size: 0.9rem;
            }

            .font-weight-bold {
                font-weight: 700 !important;
            }

            .text-primary {
                color: #007bff !important;
            }

            .small, small {
                font-size: 80%;
                font-weight: 400;
            }

            .mb-0, .my-0 {
                margin-bottom: 0 !important;
            }
        }
    }

    .v-data-table table {
        border-top: thin solid rgba(0, 0, 0, 0.12);

        tbody tr td:not(.v-data-table__mobile-row),
        thead tr th:not(.v-data-table__mobile-row) {
            border-right: thin solid rgba(0, 0, 0, 0.12);

        }

        thead tr th {
            color: #000 !important;
            padding: .75rem;
            font-size: 15px;
            vertical-align: top;
        }
    }

    #get-cookie-extension {
        display: none;
    }
</style>

<style>
    .v-messages__wrapper {
        color: red;
    }

    .content-note {
        font-size: 15px !important;
        font-weight: bold !important;
        color: #1976d2 !important;
    }
</style>
